<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['screenSize']),
    },
};
</script>

<style lang="scss"></style>
